import api from 'services/api'

export const fetchBranches = () =>
  api.get('/branches')

